/*
  Hydronate free-gift auto-add.
  Watches for qualifying variants landing in the cart and ensures the free
  "Rust Removal Guide" (eBook) is also in the cart. Works globally across
  the storefront — any product page, any custom landing page, any cart-add.

  Editable at the top of this file:
    EBOOK_VARIANT_ID        — Shopify variant ID for the free eBook product
    QUALIFYING_VARIANT_IDS  — list of variant IDs that trigger the gift
*/
(function () {
  if (window._hydFreeGiftReady) return;
  window._hydFreeGiftReady = true;

  var EBOOK_VARIANT_ID = 53688690376917; // Hydrogen Protocol Ebook / Rust Removal Guide
  var QUALIFYING_VARIANT_IDS = [
    53691643953365, // ABC offer product (Raspberry 30-day "sexual performance" landing)
    53688438259925, // Price-testing — 90-day Raspberry subscription
    53688438358229  // Price-testing — 90-day Unflavored subscription
    // Add more variant IDs here as new offer pages are launched
  ];

  var inProgress = false;
  var originalFetch = window.fetch;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var response = originalFetch.apply(this, arguments);

    if (!inProgress && url.indexOf('/cart/add') !== -1) {
      response.then(function (r) { return (r && r.ok) ? true : false; })
        .then(function (ok) { if (!ok) return null; return originalFetch('/cart.js', { credentials: 'same-origin' }); })
        .then(function (r) { return r ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          var hasQualifying = cart.items.some(function (i) { return QUALIFYING_VARIANT_IDS.indexOf(i.variant_id) !== -1; });
          var hasEbook = cart.items.some(function (i) { return i.variant_id === EBOOK_VARIANT_ID; });
          if (!hasQualifying || hasEbook) return;
          inProgress = true;
          return originalFetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: EBOOK_VARIANT_ID, quantity: 1 }] })
          }).finally(function () {
            inProgress = false;
            // Refresh the Archetype/Impulse cart drawer so the eBook appears immediately
            originalFetch('/cart?view=drawer&timestamp=' + Date.now(), { credentials: 'same-origin' })
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var temp = document.createElement('div');
                temp.innerHTML = html;
                var sidebar = document.getElementById('sidebar-cart');
                if (!sidebar) return;
                var newCart = (temp.querySelector('#sidebar-cart .Cart')) || temp.querySelector('.Cart');
                var oldCart = sidebar.querySelector('.Cart');
                if (newCart && oldCart && oldCart.parentNode) {
                  try { oldCart.parentNode.replaceChild(newCart, oldCart); } catch (_) {}
                }
              })
              .catch(function () {});
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          });
        })
        .catch(function () { /* non-fatal */ });
    }

    return response;
  };
})();
